import script from "./QuizConfirmationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizConfirmationPage.vue?vue&type=script&setup=true&lang=js"

import "./QuizConfirmationPage.vue?vue&type=style&index=0&id=a937f22a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a937f22a"]])

export default __exports__